var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6018 22.5598H6.4018C4.5818 22.5598 2.9218 21.1598 2.6218 19.3598L1.2918 11.3999C1.0818 10.1599 1.6818 8.56987 2.6718 7.77987L9.60181 2.22982C10.9418 1.14982 13.0518 1.15983 14.4018 2.23983L21.3318 7.77987C22.3118 8.56987 22.9118 10.1599 22.7118 11.3999L21.3818 19.3598C21.0818 21.1298 19.3918 22.5598 17.6018 22.5598ZM11.9918 2.93984C11.4618 2.93984 10.9318 3.09981 10.5418 3.40981L3.6118 8.95986C3.0418 9.41986 2.65181 10.4398 2.77181 11.1598L4.10181 19.1198C4.28181 20.1698 5.3318 21.0598 6.4018 21.0598H17.6018C18.6718 21.0598 19.7218 20.1698 19.9018 19.1098L21.2318 11.1499C21.3518 10.4299 20.9518 9.39985 20.3918 8.94985L13.4618 3.40981C13.0618 3.09981 12.5318 2.93984 11.9918 2.93984Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 16.25C10.21 16.25 8.75 14.79 8.75 13C8.75 11.21 10.21 9.75 12 9.75C13.79 9.75 15.25 11.21 15.25 13C15.25 14.79 13.79 16.25 12 16.25ZM12 11.25C11.04 11.25 10.25 12.04 10.25 13C10.25 13.96 11.04 14.75 12 14.75C12.96 14.75 13.75 13.96 13.75 13C13.75 12.04 12.96 11.25 12 11.25Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.96b725feab4a43cb824895ad863e066f.svg";
export { ForwardRef as ReactComponent };